<form [formGroup]="lienDetails">
  <div class="padding">
    <div class="flex-container">
      <div class="validated-form-field-container flex-container">
        <mat-form-field class="flex-item form-field" appearance="outline">
          <mat-label>{{ 'common.labels.registrationNumber' | transloco }}</mat-label>
          <input matInput data-testid="registration-number-field" [placeholder]="'common.labels.registrationNumber' | transloco"
            [formControlName]="'registrationNumber'" libReplaceCharacter>
        </mat-form-field>
        <lib-error-bubble [control]="lienDetails.controls['registrationNumber']"
        [message]="registrationNumberError$"></lib-error-bubble>
      </div>
    </div>

    <div  class="flex-container">
      <div class="validated-form-field-container flex-container">
        <mat-form-field class="form-field flex-item" appearance="outline">
          <mat-label>{{ 'common.labels.registrationDate' | transloco }}</mat-label>
          <input matInput [matDatepicker]="registrationDate" data-testid="registration-date-field" formControlName="registrationDate"
            [placeholder]="'common.labels.yyyyMmDd' | transloco" >
          <mat-datepicker-toggle matSuffix [for]="registrationDate"></mat-datepicker-toggle>
          <mat-datepicker #registrationDate></mat-datepicker>
        </mat-form-field>
        <lib-error-bubble [control]="lienDetails.get('registrationDate')!"
        [message]="registrationDateError$"></lib-error-bubble>
      </div>
    </div>

    <app-term [uiConfiguration]="uiConfiguration.lienDetailsConfiguration!" [errors$]="observableErrors$"
    [order]="order" [isDisabled]="isDisabled"></app-term>

    @if (uiConfiguration.lienDetailsConfiguration?.showAmount) {
      <div class="flex-container">
        <div class="validated-form-field-container flex-container">
          <mat-form-field class="flex-item form-field" appearance="outline">
            <mat-label>{{ 'common.labels.amount' | transloco }}</mat-label>
            <input matInput data-testid="amount-field" [placeholder]="'common.labels.amount' | transloco" type="number" [formControlName]="'amount'"
              >
          </mat-form-field>
          <lib-error-bubble [control]="lienDetails.controls['amount']"
          [message]="amountError$"></lib-error-bubble>
        </div>
      </div>
    }

    @if (uiConfiguration.lienDetailsConfiguration?.showSumOfHypothec) {
      <div class="flex-container">
        @if (isRHa) {
          <mat-form-field class="flex-item form-field" appearance="outline">
            <mat-label>{{ 'orders.sumOfHypothec' | transloco }}</mat-label>
            <textarea matInput data-testid="sum-of-hypothetic-field" [placeholder]="'common.labels.amount' | transloco" [formControlName]="'sumOfHypothec'"
            ></textarea>
          </mat-form-field>
        }
      </div>
    }

    @if (uiConfiguration.lienDetailsConfiguration?.showAdditionalInformation) {
      <div class="flex-container">
        <div class="validated-form-field-container flex-container">
          <mat-form-field class="flex-item form-field" appearance="outline">
            <mat-label>{{ 'orders.additionalInformation' | transloco }}</mat-label>
            <textarea matInput data-testid="additional-information-field" [formControlName]="'additionalInformation'"
            [placeholder]="'orders.additionalInformation2' | transloco" ></textarea>
          </mat-form-field>
          <lib-error-bubble [control]="lienDetails.controls['additionalInformation']"
          [message]="additionalInformationError$"></lib-error-bubble>
        </div>
      </div>
    }
  </div>
</form>

@if (uiConfiguration.lienDetailsConfiguration?.showSigningCountry ||
  uiConfiguration.lienDetailsConfiguration?.showSigningJurisdiction ||
  uiConfiguration.lienDetailsConfiguration?.showSigningCity ||
  uiConfiguration.lienDetailsConfiguration?.showSigningDate) {
  <div class="padding">
    <lib-signing-location [errors$]="observableErrors$" [order]="order" [isDisabled]="isDisabled"
    (signingLocationFormValueChangedEvent)="handleSigningLocationFormValueChangedEvent()"></lib-signing-location>
  </div>
}